<template>
  <div class="attention-container">
    <!-- 金银铜tabs -->
    <vip-company-choose @listTypeChange="listTypeChange" :listType="listType"></vip-company-choose>
    <!-- 顶部面包屑 -->
    <md-breadcrumb :dataSource="cateParents" @breadcrumbClick="breadcrumbClick"></md-breadcrumb>
    <!-- 供应链企业 -->
    <attention-list
      :treeDirId="dirId"
      :listType="listType"
      ref="attentionListRef"
      v-show="listType.includes('Enterprise')"
    ></attention-list>
    <!-- 金银铜企业推荐列表 -->
    <vip-company-list :listType="listType" ref="vipCompanyListRef" v-show="listType.includes('vipLevel')"></vip-company-list>
    <!-- 我的常用零配件 -->
    <lecto-favorite
      :dirId="dirId"
      :listType="listType"
      :cateParents="cateParents"
      ref="lectoFavoriteRef"
      v-show="listType.includes('LectoFavorite')"
    ></lecto-favorite>

    <product-library
      :dirId="dirId"
      :listType="listType"
      :cateParents="cateParents"
      ref="prodDirRef"
      v-show="listType.includes('ProdDir')"
    ></product-library>
  </div>
</template>

<script>
import VipCompanyChoose from './vip-company/vip-company-choose.vue';
import MdBreadcrumb from "@/components/md-breadcrumb/md-breadcrumb.vue";

import VipCompanyList from './vip-company/vip-company-list.vue';
import LectoFavorite from './lecto-favorite/lecto-favorite.vue';
import AttentionList from './attention-list/attention-list.vue';
import ProductLibrary from './product-library/index.vue';

export default {
  components: { MdBreadcrumb, VipCompanyChoose, VipCompanyList, LectoFavorite, AttentionList, ProductLibrary },
  data() {
    return {
      listType: '', // 当前列表展示数据类型
      listTypeOld: '',
      dirId: -1,
      cateParents: [{DirName: '我的桌面', DirID: 0, TreeID: 0}],
    };
  },
  mounted() {},
  methods: {
    // 当前dirid改变
    dirChanged(dirId, cateParents, listType = '') {
      this.cateParents = cateParents.reverse();
      this.listType = listType;
      this.listTypeOld = listType;
      this.dirId = dirId;
    },

    // 重新计算树DataCount
    dragDataCallback() {
      this.$parent.dragDataCallback(...arguments)
    },
    // 推荐供应商弹窗
    compRecommOpen() {
      this.$parent.compRecommOpen();
    },

    breadcrumbClick(value) {
      this.$parent.$refs.enterpriseTree.select(`list_${value.DirID}`);
    },
    listTypeChange(value = '') {
      this.listType = value || this.listTypeOld;
      this.page = 1;
      if (value == '') {
        // this.$parent.$refs.enterpriseTree.select('list_0');
      } else {
        this.$refs.vipCompanyListRef.resetList(value);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.attention-container{
  flex: 1;
  position: relative;
  overflow-x: auto;
  /deep/ .md-breadcrumd{
    padding: 5px;
    border-bottom: 1px solid @line-strong-color;
  }
}
</style>
